module.exports = __webpack_public_path__ + "img/station-mobile.a728f3be.png";